import { StatusBadge } from "@/components/StatusBadge";
import { fmtDate } from "@/lib/constants";
import { CheckCircle2, Circle, Loader2 } from "lucide-react";

export default function StageTracker({ stages, onStageAction, actionLabel, simple }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3" data-testid="stage-tracker">
      {stages.map((s, i) => {
        const Icon = s.status === "completed" ? CheckCircle2 : s.status === "in_progress" ? Loader2 : Circle;
        return (
          <div
            key={s.name}
            data-testid={`stage-card-${i}`}
            className="rounded-lg border border-border bg-card p-4 corner-tick animate-fade-up"
            style={{ animationDelay: `${i * 30}ms` }}
          >
            <div className="flex items-start justify-between gap-2 mb-2">
              <div className="flex items-center gap-2 min-w-0">
                <span className="font-mono-tag text-xs text-muted-foreground">{String(i + 1).padStart(2, "0")}</span>
                <Icon className={`h-4 w-4 shrink-0 ${s.status === "completed" ? "text-emerald-400" : s.status === "in_progress" ? "text-amber-400" : "text-slate-500"}`} />
                <span className="font-heading font-semibold text-sm truncate">{s.name}</span>
              </div>
              <StatusBadge status={s.status} testId={`stage-status-${i}`} />
            </div>
            {!simple && s.custom_label && <p className="text-sm font-medium">{s.custom_label}</p>}
            {!simple && s.notes && <p className="text-sm text-muted-foreground mt-1">{s.notes}</p>}
            {!simple && s.metrics && (
              <p className="text-xs font-mono-tag text-secondary mt-1">metrics: {s.metrics}</p>
            )}
            {!simple && s.finalised_by && (
              <p className="text-xs text-muted-foreground mt-2">
                Finalised by {s.finalised_by} · {fmtDate(s.finalised_at)}
              </p>
            )}
            {!simple && onStageAction && (
              <button
                onClick={() => onStageAction(s)}
                data-testid={`stage-action-${i}`}
                className="mt-3 text-xs font-medium text-primary hover:underline"
              >
                {actionLabel}
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
}
